
import { defineComponent } from 'vue'

export default defineComponent({
  computed: {
    token: {
      get() {
        return this.$store.state.token
      },
      set(value: string) {
        this.$store.commit('setToken', value)
      },
    },
  },
})
